// 过期

import React from 'react'
import PropTypes from 'prop-types'
import expired from '@/assets/images/expired.png'
import nointerest from '@/assets/images/nointerest.png'
import './index.less'

function Expired ({ effectStatus }) {
    const showImg = effectStatus === '1' ? nointerest : expired
    const showData = effectStatus === '1' ? '活动权益陆续开放中，敬请期待' : '来晚了，次活动已经结束了！'
    return (
        <React.Fragment>
            <div className="activity-body">
                <img src={showImg} alt="" />
                <div className="activitydebodytext">{showData}</div>
            </div>
        </React.Fragment>
    )
}
Expired.propTypes = {
    effectStatus: PropTypes.string
}
export default Expired
